import {
  displayValueWithMultiplier,
  displayDisplacementWithMultiplier,
  formatDerInfoSeconds,
  displayGradW,
  displayFormattedNumberWithPrefixAndMultiplier
} from '../format';

import { UNIT_STRINGS } from '../appConstants';

export const DerSettingsSchema = {
  derId: {
    // no toDisplayString, since it will not be displayed.
  },
  modesEnabled: {
    // no toDisplayString, since it will not be displayed.
  },
  updatedTime: {
    // no toDisplayString, since it will not be displayed.
  },
  setESDelay: {
    // seconds
    powerOfTen: 0, // to compensate for the durationFormatter
    toDisplayString: formatDerInfoSeconds
  },
  setESHighFreq: {
    displayUnits: UNIT_STRINGS.FREQUENCY,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESHighVolt: {
    displayUnits: UNIT_STRINGS.PERCENT,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESLowFreq: {
    displayUnits: UNIT_STRINGS.FREQUENCY,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESLowVolt: {
    displayUnits: UNIT_STRINGS.PERCENT,
    powerOfTen: -2,
    toDisplayString: displayFormattedNumberWithPrefixAndMultiplier
  },
  setESRampTms: {
    // seconds
    powerOfTen: 0,
    toDisplayString: formatDerInfoSeconds
  },
  setESRandomDelay: {
    // seconds
    powerOfTen: 0,
    toDisplayString: formatDerInfoSeconds
  },
  setGradW: {
    displayUnits: UNIT_STRINGS.MAXW_PER_SECOND,
    powerOfTen: -2,
    toDisplayString: displayGradW
  },
  setSoftGradW: {
    displayUnits: UNIT_STRINGS.MAXW_PER_SECOND,
    powerOfTen: -2,
    toDisplayString: displayGradW
  },
  setMaxA: {
    displayUnits: UNIT_STRINGS.CURRENT_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxAh: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxChargeRateVA: {
    displayUnits: UNIT_STRINGS.APPARENT_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxChargeRateW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxDischargeRateVA: {
    displayUnits: UNIT_STRINGS.APPARENT_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxDischargeRateW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxV: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxVA: {
    displayUnits: UNIT_STRINGS.APPARENT_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxVar: {
    displayUnits: UNIT_STRINGS.REACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxVarNeg: {
    displayUnits: UNIT_STRINGS.REACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxW: {
    displayUnits: UNIT_STRINGS.ACTIVE_POWER,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMaxWh: {
    displayUnits: UNIT_STRINGS.WATT_HOURS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setMinPFOverExcited: {
    displayUnits: UNIT_STRINGS.POWER_FACTOR,
    powerOfTen: 0,
    toDisplayString: displayDisplacementWithMultiplier
  },
  setMinPFUnderExcited: {
    displayUnits: UNIT_STRINGS.POWER_FACTOR,
    powerOfTen: 0,
    toDisplayString: displayDisplacementWithMultiplier
  },
  setMinV: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setVNom: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setVRef: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  },
  setVRefOfs: {
    displayUnits: UNIT_STRINGS.VOLTAGE_RMS,
    powerOfTen: 0,
    toDisplayString: displayValueWithMultiplier
  }
};
